export default __webpack_public_path__ + "static/media/new.27eff5b0.png";